<ng-select [searchFn]="searchFn" [appendTo]="appendTo" [clearable]="clearable" [items]="data$ | async" bindLabel="name" [placeholder]="placeholder" [searchable]="true" [multiple]="multiple" [closeOnSelect]="closeOnSelect" [hideSelected]="hideSelected" [formControl]="control">
    <ng-template ng-option-tmp let-item="item">
        {{item?.name}}
    </ng-template>

    <ng-template ng-label-tmp let-item="item" let-clear="clear">
        {{item?.name}}
    </ng-template>
</ng-select>